"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIVE_DOMAIN = exports.SLUG = exports.ABSOLUTE_URL = exports.LANGUAGE = exports.NAME = exports.LANDING_PAGES = exports.IS_PUBLISHED = exports.ID = void 0;
var ID = 'id';
exports.ID = ID;
var IS_PUBLISHED = 'isPublished';
exports.IS_PUBLISHED = IS_PUBLISHED;
var LANDING_PAGES = 'LandingPages';
exports.LANDING_PAGES = LANDING_PAGES;
var NAME = 'name';
exports.NAME = NAME;
var LANGUAGE = 'language';
exports.LANGUAGE = LANGUAGE;
var ABSOLUTE_URL = 'absoluteUrl';
exports.ABSOLUTE_URL = ABSOLUTE_URL;
var SLUG = 'slug';
exports.SLUG = SLUG;
var LIVE_DOMAIN = 'liveDomain';
exports.LIVE_DOMAIN = LIVE_DOMAIN;